import { useTranslation } from 'react-i18next';
import { CompanyDetailAndJobGroups } from '@types';
import { Header, Page } from 'redesign';
import { SettingsDetail } from './settings-detail/settings-detail';
import { SettingsDetailToolbox } from './settings-detail/settings-detail-toolbox';
import { CompanyDataProvider } from '../../management/company/company-data-provider';

export const SettingsPageDataProvider = () => {
  return (
    <CompanyDataProvider>
      {(companyData) => <SettingsPage companyData={companyData} />}
    </CompanyDataProvider>
  );
};

const SettingsPage = (props: { companyData: CompanyDetailAndJobGroups }) => {
  const { t } = useTranslation('ogp-screen-specific');

  return (
    <Page
      toolbox={<SettingsDetailToolbox />}
      header={<Header titleText={t('settings-detail-page.title')} />}
    >
      <SettingsDetail companyData={props.companyData} />
    </Page>
  );
};
